import { render } from "./POSPageSkeleton.vue?vue&type=template&id=433e8974&scoped=true"
import script from "./POSPageSkeleton.vue?vue&type=script&lang=js"
export * from "./POSPageSkeleton.vue?vue&type=script&lang=js"

import "./POSPageSkeleton.vue?vue&type=style&index=0&id=433e8974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433e8974"]])

export default __exports__